import { IFileWithMeta } from '@swvl/file-upload';
import { StepProps } from './types';
import { Step } from './step';
import type { CorporateConfigs } from './resources';
import { BasicCorporateLevelStep } from '@customers/generate-rides/basic-corporate-level-step';

export const CorporateLevelStep = (
  props: StepProps & {
    initialCorporateConfigs?: CorporateConfigs;
    setCorpConfigsStep: (corpsStep: string) => void;
    corpConfigsStep: string;
    setFile: (file: IFileWithMeta) => void;
  },
) => {
  return (
    <Step {...props} hideLabel>
      <div>
        <BasicCorporateLevelStep
          key="BasicCorporateLevelStep"
          label="Basic Corporate level settings"
          hideLabel
          generateRidesData={props.generateRidesData}
          initialCorporateConfigs={props.initialCorporateConfigs}
        />
      </div>
    </Step>
  );
};
